interface Position {
  idx: number;
  x: number;
  y: number;
}

interface LatLngItem {
  lat: number;
  lng: number;
}

export const calculateOverlayStackIndexes = (
  placements: LatLngItem[],
  projection: google.maps.MapCanvasProjection | null,
  logoSize = 68,
  margin = 8
): { [idx: number]: 0 | 1 } => {
  if (!projection) return {};

  const positions: Position[] = placements.reduce<Position[]>(
    (acc, item, idx) => {
      const latLng = new window.google.maps.LatLng(item.lat, item.lng);
      const point = projection.fromLatLngToDivPixel(latLng);
      if (point) acc.push({ idx, x: point.x, y: point.y });
      return acc;
    },
    []
  );

  const stack: { [idx: number]: 0 | 1 } = {};

  for (let i = 0; i < positions.length; i += 1) {
    let overlap = false;
    for (let j = 0; j < i; j += 1) {
      if (stack[positions[j].idx] === 0) {
        const posA = positions[i];
        const posB = positions[j];
        const ax1 = posA.x - logoSize / 2;
        const ay1 = posA.y - logoSize - margin;
        const ax2 = posA.x + logoSize / 2;
        const ay2 = posA.y - margin;
        const bx1 = posB.x - logoSize / 2;
        const by1 = posB.y - logoSize - margin;
        const bx2 = posB.x + logoSize / 2;
        const by2 = posB.y - margin;
        if (ax1 < bx2 && ax2 > bx1 && ay1 < by2 && ay2 > by1) {
          overlap = true;
          break;
        }
      }
    }
    stack[positions[i].idx] = overlap ? 1 : 0;
  }

  return stack;
};
